import { ServiceException } from '@inter-ikea-kompis/exceptions';
import AccountServiceEnum from './enums/AccountServiceEnum.js';
import AccountCookieUtility from './utilities/AccountCookieUtility.js';
/**
 * This class is used for managing DexfAccountService tokens stored in cookies.
 */
export default class DexfAccountServiceStorage {
    /**
     * Removes all DexfAccountService token cookies.
     */
    static clearAllTokens() {
        AccountCookieUtility.removeCookie(AccountServiceEnum.idToken);
        AccountCookieUtility.removeCookie(AccountServiceEnum.accessToken);
        AccountCookieUtility.removeCookie(AccountServiceEnum.codeVerifier);
    }
    /**
     * Retrieves the PKCE cookie and removes it.
     *
     * @returns The PKCE value, or error if not found.
     */
    static getPkce() {
        const pkce = AccountCookieUtility.getCookie(AccountServiceEnum.pkce);
        if (!pkce) {
            throw new ServiceException(`Failed to get Proof Key for Code Exchange (PKCE).`);
        }
        AccountCookieUtility.removeCookie(AccountServiceEnum.pkce);
        return pkce;
    }
    /**
     * Retrieves the Code Verifier value from cookies and removes it.
     *
     * @returns The Code Verifier value, or error if not found.
     */
    static getCodeVerifier() {
        const code = AccountCookieUtility.getCookie(AccountServiceEnum.codeVerifier);
        if (!code) {
            return null;
        }
        AccountCookieUtility.removeCookie(AccountServiceEnum.codeVerifier);
        return code;
    }
    /**
     * Remove code verifier cookie.
     *
     */
    static removeCodeVerifier() {
        AccountCookieUtility.removeCookie(AccountServiceEnum.codeVerifier);
    }
    /**
     * Retrieves the authentication in progress cookie.
     *
     * @returns True if the authentication is in progress, otherwise false.
     */
    static getAuthenticationState() {
        const state = AccountCookieUtility.getCookie(AccountServiceEnum.authenticationInProgress);
        // If the state is not 'true', this will return false
        if (state !== 'true') {
            return false;
        }
        return true;
    }
    /**
     * Remove authentication state cookie.
     */
    static removeAuthenticationState() {
        AccountCookieUtility.removeCookie(AccountServiceEnum.authenticationInProgress);
    }
    /**
     * Retrieves a token cookie.
     *
     * @param tokenName The name of the token to retrieve.
     * @returns The token value, or null if not found.
     */
    static getToken(tokenName) {
        return AccountCookieUtility.getCookie(tokenName);
    }
    /**
     * Stores the PKCE value.
     *
     * @param pkce The PKCE value to store.
     */
    static storePkce(pkce) {
        AccountCookieUtility.setCookie(AccountServiceEnum.pkce, pkce);
    }
    /**
     * Stores the Code Verifier value in cookie.
     *
     * @param code The Code Verifier value to store.
     */
    static storeCodeVerifier(code) {
        AccountCookieUtility.setCookie(AccountServiceEnum.codeVerifier, code);
    }
    /**
     * Stores the authentication in progress state value in cookie.
     *
     * @param state The authentication in progress state value to store.
     */
    static storeAuthenticationState(state) {
        AccountCookieUtility.setCookie(AccountServiceEnum.authenticationInProgress, state.toString());
    }
    /**
     * Stores tokens in cookie.
     *
     * @param tokens An object containing the tokens to store.
     */
    static storeTokens(tokens) {
        AccountCookieUtility.setCookie(AccountServiceEnum.idToken, tokens.id_token);
        AccountCookieUtility.setCookie(AccountServiceEnum.accessToken, tokens.access_token);
    }
}
//# sourceMappingURL=DexfAccountServiceStorage.js.map